<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'thirdReserveManage')">
            <a-card v-if="shopId != -1" :bordered="false">
                <a-button v-if="getBtnByAuth('queryReserve')" slot="extra" type="primary" @click="toThirdPartySearch">预约信息查询</a-button>
                <a-button v-if="getBtnByAuth('batchClosePark')" slot="extra" type="primary" @click="openModalClosed('批量闭园',{})">批量闭园</a-button>
                <a-button v-if="getBtnByAuth('helpUserReserve')" slot="extra" type="primary" @click="openModal">帮客人预约</a-button>
                <a-button v-if="getBtnByAuth('operatorReserve')" slot="extra" type="primary" @click="toAddCode">预约管理</a-button>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="record => record.id"
                    >
                    <template slot="stockNum" slot-scope="stockNum,row">
                        <a-input-number v-if="row.isEdit" :precision="0" :min="0" v-model="row.stockNum" @change="onChangeNum"/>
                        <span v-else>{{stockNum}}</span>
                    </template>
                    <span slot="action" slot-scope="a,row">
                        <template v-if="getBtnByAuth('userReserveDownload') && !row.isEdit">
                            <a class="text-primary" @click="download(row)">名单下载</a>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-if="!row.isEdit">
                            <a class="text-primary" @click="row.isEdit = true">修改容量</a>
                            <a-divider type="vertical"/>
                        </template>
                        <template v-else>
                            <a class="text-primary" @click="updateStockDay(row.id)">确定</a>
                            <a-divider type="vertical"/>
                            <a class="text-primary" @click="getList">取消</a>
                        </template>
                        <a-divider v-if="getBtnByAuth('closePark')" type="vertical"/>
                        <a-popconfirm
                            v-if="getBtnByAuth('userReserveDownload') && row.closeState == 1"
                            title="确认将该日期取消闭园吗？"
                            @confirm="cancelClosed(row)"
                            >
                            <a class="text-primary">取消闭园</a>
                        </a-popconfirm>
                        <a v-if="getBtnByAuth('closePark') && row.closeState == 2" class="text-primary" @click="openModalClosed('闭园',row)">闭园</a>
                    </span>
                </a-table>
            </a-card>
			<a-empty class="pt24 pb24" v-else >
				<span slot="description" class="font-big22">请切换到各门店查看</span>
			</a-empty>
            <a-modal :visible="showModal" title="预约" centered @cancel="onCancel" @ok="onOk" :confirmLoading="loading">
                <a-form :form="form">
                    <a-form-item label="游客手机号" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-input
                        placeholder="请输入"
                        v-decorator="['phone',{rules: [{required: true, message: '请输入游客手机号'}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="预约日期" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-date-picker style="width: 60%" format="YYYY-MM-DD" :disabled-date="disabledDate" @change="onChangeDate" v-decorator="['reserveDate', {rules: [{ required: true, message: '请选择预约日期' }]}]"/>
                        <span class="ml8">可预约人数：{{remainderNum || 0}}</span>
                    </a-form-item>
                    <a-form-item label="游客人数" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-input-number
                        style="width: 100%"
                        placeholder="请输入"
                        :precision="0"
                        :min="1"
                        v-decorator="['reserveNum',{rules: [{required: true, message: '请输入游客人数'}]}]"
                        />
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal :visible="showModalClosed" :title="changeRow.title" centered @cancel="onCancelClosed" @ok="onOkClosed" :confirmLoading="confirmLoading">
                <a-form :form="formClosed">
                    <a-form-item label="闭园时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-range-picker :disabled="changeRow.title == '闭园'" :disabled-date="disabledDateClose" v-decorator="['stockDay',{initialValue: changeRow.title == '闭园' ? [$moment(changeRow.stockDay),$moment(changeRow.stockDay)] : null, rules: [{ required: true, message: '请选择' }]}]"/>
                    </a-form-item>
                    <a-form-item label="短信内容" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-textarea 
						placeholder="最多输入150个字符" 
						:maxLength="150" 
						:autosize="{ minRows: 3, maxRows: 8 }"
						v-decorator="['content', {rules: [{required: true, message: '请输入发送的短信内容'}]}]"
						></a-textarea>
						<span>{{formClosed.getFieldValue('content') ? formClosed.getFieldValue('content').length : 0}}/150</span>
                    </a-form-item>
                    <a-form-item label="短信预览" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                        <a-textarea 
						:autosize="{ minRows: 3, maxRows: 8 }"
						disabled
						:placeholder="'【阿派朗】'+(formClosed.getFieldValue('content') || '')"
						/>
                    </a-form-item>
                    <span class="text-fail">*如果闭园当天有游客已经预约，会给游客发送短信通知。</span>
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "thirdReserveManage",
        components: {},
        props: {},
        data() {
            const columns = [
            {
                title: "日期",
                dataIndex: "stockDay",
            },
            {
                title: "预约容量",
                dataIndex: "stockNum",
                scopedSlots: { customRender: "stockNum" }
            },
            {
                title: "已预约人数",
                dataIndex: "reserveNum",
            },
            {
                title: "预约余量",
                dataIndex: "remainderNum",
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" }
            }
            ];
            return {
                form: this.$form.createForm(this),
                formClosed: this.$form.createForm(this),
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                showModal: false,
                loading: false,
                remainderNum: undefined,
                updateStockNum: 0,
                showModalClosed: false,
                confirmLoading: false,
                changeRow: {},
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                if(!this.shopId) return
                this.$api.changeCode.thirdReserveList({
                    body: {
                        // reserveDate: this.$moment().format('YYYY-MM-DD'),
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        shopId: this.shopId
                    }
                })
                .then(res => {
                    this.pagination.total = res.total;
                    res.list.map(e => e.isEdit = false)
                    this.dataSource = res.list;
                });
            },
            download(row) {
                this.$message.success('下载中，请稍后...')
                this.$api.changeCode
                .thirdReserveExport({
                    body: row
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    //let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'
                    let name = row.stockDay + '预约名单.xlsx'

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();

                });
            },

            // 跳转至新增页
            toAddCode() {
                this.$router.push({
                    name: "editReserve",
                });
            },
            disabledDate(current) {
                return current && current < this.$moment().endOf('day').add(-1, 'days');
            },
            disabledDateClose(current) {
                return current && current < this.$moment().endOf('day').add(-1, 'days');
            },
            openModal() {
                this.showModal = true;
            },
            cancelClosed(row) {
                this.$api.changeCode.closeDay({
                    body: {
                        stockDay: row.stockDay,
                        stockEndDay: row.stockDay,
                        id: row.id,
                        closeState: 2, // 开园
                        shopId: this.shopId,
                    }
                }).then(data=>{
                    this.$message.success('操作成功')
                    this.getList();
                })
            },
            openModalClosed(title,row = {}) {
                this.showModalClosed = true;
                this.changeRow = row;
                this.changeRow.title = title;
            },
            onChangeDate(e,value) {
                this.$api.changeCode.userReserveDay({
                    body: {
                        shopId: this.shopId,
                        dayNum: 1,
                        start: value
                    }
                }).then(res=>{
                    this.remainderNum = res[0].remainderNum;
                }).catch(err => {
                    this.loading = false
                })
            },
            onCancel() {
                this.showModal = false;
                this.form.resetFields();
            },
            onCancelClosed() {
                this.showModalClosed = false;
                this.changeRow = {};
                this.formClosed.resetFields();
            },
            onOk() {
                this.form.validateFields((err, values) => {
                    if (err) return
                    values.reserveDate = values.reserveDate.format('YYYY-MM-DD');
                    values.shopId = this.shopId;
                    values.name = '后台代预约';
                    values.code = '0000';
                    this.loading = true;
                    this.$api.changeCode.staffHelpUserReserve({
                        body: values
                    }).then(data=>{
                        this.$message.success('预约成功')
                        this.onCancel();
                        this.getList();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
            onOkClosed() {
                this.formClosed.validateFields((err, values) => {
                    if (err) return
                    if(this.changeRow.title == '闭园') {
                        values.stockDay = this.changeRow.stockDay;
                        values.stockEndDay = this.changeRow.stockDay;
                    }else {
                        const rangeValue = values['stockDay'] ? values['stockDay'] : [];
                        values.stockDay = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD') : undefined;
                        values.stockEndDay = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD') : undefined;
                    }
                    values.shopId = this.shopId;
                    values.closeState = 1; //闭园
                    this.confirmLoading = true;
                    this.$api.changeCode.closeDay({
                        body: values
                    }).then(data=>{
                        this.$message.success('操作成功')
                        this.onCancelClosed();
                        this.getList();
                        this.confirmLoading = false;
                    }).catch(err => {
                        this.confirmLoading = false
                    })
                });
            },
            onChangeNum(e) {
                this.updateStockNum = e;
            },
            updateStockDay(id) {
                this.$api.changeCode.updateStockDay({
                    body: {
                        id: id,
                        stockNum: this.updateStockNum
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                })
            },
            toThirdPartySearch() {
                this.$router.push({name: 'thirdPartySearch'})
            }
        },
        beforeCreate() {},
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            $route(val) {
                val.name == "thirdReserveManage" && this.getList();
            },
            'shopId'() {
                this.getList()
            }
        }
    };
</script>